<woa-modal-page-layout [title]="'woa.heading.wallet-payment.title'" [showContent]="false">
    <woa-order-totals-panel slot="footer-start" class="payment-totals" [totalOnly]="true"></woa-order-totals-panel>
    @if (paymentModel.walletPaymentProcessor().walletProvider() === WalletProvider.APPLE_PAY) {
        <woa-apple-pay-button woa-page-footer-control
                              id="apple-pay-button" [type]="'plain'"
                              (pay)="pay()"
                              (paymentStarted)="paymentStarted()"
                              (paymentComplete)="paymentComplete($event)"
                              (paymentFailed)="paymentFailed($event)"
                              (paymentCancelled)="paymentCancelled()"></woa-apple-pay-button>
    }
    @if (paymentModel.walletPaymentProcessor().walletProvider() === WalletProvider.GOOGLE_PAY) {
        <woa-google-pay-button woa-page-footer-control
                               id="google-pay-button" [type]="'plain'"
                               (pay)="pay()"
                               (paymentStarted)="paymentStarted()"
                               (paymentComplete)="paymentComplete($event)"
                               (paymentFailed)="paymentFailed($event)"
                               (paymentCancelled)="paymentCancelled()"></woa-google-pay-button>
    }
</woa-modal-page-layout>
